import artwork from "./character";
import bodyURL from "./assets/body/body.png";
import wingsURL from "./assets/wings/wings.png";
import tipURL from "./assets/antennae/tip.svg?url";

export { artwork };
export const artworkMarkup = artwork.markup.replace(
  /\b(src|href)="(assets\/[^\"]+)"/g,
  (_, attribute, path) =>
    `${attribute}="${
      {
        "assets/body/body.png": bodyURL,
        "assets/wings/wings.png": wingsURL,
        "assets/antennae/tip.svg": tipURL,
      }[path]
    }"`
);

// Decorative instances share the exact artwork, but SVG clip IDs must be
// unique within their ShadowRoot. The main mascot markup stays unchanged.
export function artworkForInstance(prefix) {
  if (!/^[a-z][a-z0-9_-]*$/i.test(prefix))
    throw new Error("FireflyMascot: неверный префикс рисунка");
  return artworkMarkup
    .replace(/\bid="([^"]+)"/g, (_, id) => `id="${prefix}-${id}"`)
    .replace(/url\(#([^)]+)\)/g, (_, id) => `url(#${prefix}-${id})`)
    .replace(
      /\b(href|xlink:href)="#([^"]+)"/g,
      (_, attr, id) => `${attr}="#${prefix}-${id}"`
    );
}
